import { api } from './client'

/**
 * TASK-0148: consumer for `LeadRoutingRulesController` (TASK-0109, already complete and
 * reviewed on the backend — see `platform/Backend/src/Modules/Leads/EqualCrm.Modules.Leads/Api/LeadRoutingRulesController.cs`).
 * Shape matches the controller's `List`/`Get` projection exactly (`Id, Name, Conditions,
 * TargetAgentId, Priority, IsActive, CreatedAt, UpdatedAt`), camelCased the same way every other
 * `api/*.ts` module in this codebase mirrors a PascalCase backend entity (see `Department` in
 * `./team.ts`).
 */
export type LeadRoutingMode = 'single' | 'round_robin' | 'weighted'

export interface LeadRoutingMember {
  userId: number
  weight: number
  /** null = nessun tetto di lead aperti. */
  maxOpenLeads: number | null
  assignedCount: number
  /** F-088: settori abilitati per il membro; null = tutti i settori. */
  enabledSectors?: string[] | null
}

export interface LeadRoutingMemberBody {
  userId: number
  weight?: number | null
  maxOpenLeads?: number | null
  /** F-088: settori abilitati; null o vuoto = tutti. */
  enabledSectors?: string[] | null
}

export interface LeadRoutingRule {
  id: number
  name: string
  /** Raw JSON array of `{field, operator, value}` objects — see `LeadRoutingRule.cs`'s doc
   * comment on `Conditions`. Deliberately a plain string here, not a typed model: the backend
   * itself stores and validates it as JSON text, not a parsed shape, so the condition vocabulary
   * can grow without a contract change on either side. */
  conditions: string
  targetAgentId: number
  priority: number
  isActive: boolean
  /** F-054: `single` (storico), `round_robin` o `weighted`. */
  mode: LeadRoutingMode
  /** F-054: membri del gruppo (vuoto per `single`); `assignedCount` e' operativo, sola lettura. */
  members: LeadRoutingMember[]
  createdAt: string
  updatedAt: string
}

/** Body for create/update — mirrors `LeadRoutingRuleRequest(Name, Conditions, TargetAgentId,
 * Priority = 0, IsActive = true)` on the backend field-for-field. */
export interface LeadRoutingRuleRequestBody {
  name: string
  conditions: string
  targetAgentId: number
  priority?: number
  isActive?: boolean
  /** F-054: omesso = il backend lascia invariati modalita' e membri. */
  mode?: LeadRoutingMode
  members?: LeadRoutingMemberBody[]
}

export const leadRoutingRulesApi = {
  list: () => api<LeadRoutingRule[]>('/api/lead-routing-rules'),
  create: (data: LeadRoutingRuleRequestBody) =>
    api<{ id: number }>('/api/lead-routing-rules', { method: 'POST', body: JSON.stringify(data) }),
  update: (id: number, data: LeadRoutingRuleRequestBody) =>
    api<void>(`/api/lead-routing-rules/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  delete: (id: number) =>
    api<void>(`/api/lead-routing-rules/${id}`, { method: 'DELETE' }),
}
